if (!customElements.get('multidomain-language-selector')) {
  customElements.define(
    'multidomain-language-selector',
    class MultidomainLanguageSelector extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button.localization-form__select');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        if (!this.button || !this.panel) return;
        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }

      onButtonClick(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-expanded') === 'true') {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.close();
        }
      }

      onKeyUp(event) {
        if (event.code === 'Escape') {
          this.close();
          this.button.focus();
        }
      }
    }
  );
}
